import { WarningBanner } from 'ui/banner';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useUpdateIngestionPolicies } from '../hooks';

export const TEXT = {
  ID: 'discard-event-modal',
  BANNER:
    'Deactivated events are not automatically deleted and will continue to count toward your billed event total. Update the event’s retention policy to delete these events.',
  CONFIRM_BUTTON: 'Deactivate event',
  DESCRIPTION:
    'New instances of this event will be blocked from entering Iterable and hidden from appearing and being used throughout the application.',
};

export const headerText = (eventName: string) => `Deactivate ${eventName}?`;

type Props = {
  eventName: string;
  onClose: () => void;
};

export const DeactivateEventModal = ({ onClose, eventName }: Props) => {
  const { deactivate } = useUpdateIngestionPolicies();

  const deactivateEvent = async () => {
    await deactivate(eventName);
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{headerText(eventName)}</ModalHeader>
      <ModalBody>
        <Body2>{TEXT.DESCRIPTION}</Body2>
        <WarningBanner Icon={false}>{TEXT.BANNER}</WarningBanner>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton onClick={deactivateEvent} size={BUTTON_SIZES.LARGE}>
          {TEXT.CONFIRM_BUTTON}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
